import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Client from 'src/store/models/Client';
import { dialog } from 'src/boot/mixins';
import { colorUtils } from 'src/mixins/colors-utils';
import { cloneDeep } from 'lodash';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [dialog, colorUtils],
  components: {
    TeDialog: TeDialog,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: ['clientId', 'name', 'onComplete'],
  data: function data() {
    return {
      myClient: {
        color: null,
        client_id: null,
        name: ''
      },
      loading: false
    };
  },
  computed: {
    client: function client() {
      return Client.find(this.clientId);
    }
  },
  methods: {
    saveClient: function saveClient() {
      var _this = this;

      var url = '/clients',
          method = 'post';

      if (this.myClient.client_id) {
        url += '/' + this.myClient.client_id;
        method = 'put';
      }

      this.loading = true;
      Client.api()[method](url, this.myClient).then(function (result) {
        _this.$q.notify({
          message: _this.myClient.client_id ? _this.$t('components.clientDialog.updated_last_client') : _this.$t('components.clientDialog.created_last_client'),
          type: 'positive'
        });

        _this.loading = false;

        _this.onOKClick(result.response.data);
      }).catch(function () {});
    },
    deleteClient: function deleteClient() {
      var _this2 = this;

      this.openDialog('ClientsDeleteDialog', {
        selectedItems: [this.client],
        onDelete: function onDelete() {
          _this2.loading = true;
          Client.api().delete('/clients/' + _this2.myClient.client_id, {
            delete: _this2.myClient.client_id
          }).then(function () {
            _this2.$q.notify({
              message: _this2.$t('components.clientDialog.deleted_client'),
              type: 'positive'
            });

            _this2.loading = false;

            _this2.onOKClick('deleted');
          }).catch(function () {});
        }
      }, this);
    },
    showClientArchiveDialog: function showClientArchiveDialog() {
      if (!this.me.account.hasFeatureAccess('clients_archive')) {
        this.$refs.archiveUpgrade.showTooltip();
        return;
      }

      this.openDialog('UserConfirmationDialog', {
        type: 'warning',
        icon: 'fal:briefcase',
        title: this.$t('general.archive_clients'),
        html: true,
        message: this.$t('components.clientDialog.you_are_about_to_archive_name', {
          name: this.myClient.name
        }),
        onConfirm: this.archiveClient
      });
    },
    archiveClient: function archiveClient() {
      var _this3 = this;

      this.showLoading(this.$t('components.clientDialog.archiving_client'));
      Client.api().massArchive({
        client_ids: [this.client.client_id]
      }).then(function () {
        _this3.$q.notify({
          message: _this3.$t('components.clientDialog.client_archived'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this3.hideLoading();
      });
    },
    unarchiveClient: function unarchiveClient() {
      var _this4 = this;

      this.showLoading(this.$t('components.clientDialog.un_archiving_client'));
      Client.api().massUnarchive({
        client_ids: [this.client.client_id]
      }).then(function () {
        _this4.$q.notify({
          message: _this4.$t('components.clientDialog.client_unarchived'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this4.hideLoading();
      });
    }
  },
  mounted: function mounted() {
    if (this.clientId) {
      this.myClient = cloneDeep(this.client);
    } else {
      if (this.name) {
        this.myClient.name = this.name;
      }

      this.myClient.color = this.getRandomColor();
    }
  }
};